const AppStore = () => {
  return (
    <div className="w-full h-full flex flex-col pt-4">
      {/* Заголовок */}
      <div className="w-full mb-10 px-4">
        <h1 className="text-3xl sm:text-4xl md:text-5xl text-center font-medium bg-gradient-to-r from-[#FC5EB2] to-[#444CE7] bg-clip-text text-transparent leading-snug">
          Download our app
          <br /> and get your skincare
          <br /> plan anytime
        </h1>
      </div>

      {/* Блок с телефоном */}
      <div className="relative w-full h-[55vh] min-h-[380px] max-h-[400px] px-4 flex flex-col items-center justify-center overflow-hidden">
        {/* Фоновой вектор */}

        <img
          loading="lazy"
          className="absolute w-[90%] max-w-[900px] h-auto"
          style={{ left: "50%", transform: "translateX(-50%)", bottom: "8%" }}
          src="/vectorAppStore.svg"
          alt="Vector background"
        />

        <img
          loading="lazy"
          className="absolute w-[65%] max-w-[500px] h-auto"
          style={{ left: "50%", transform: "translateX(-50%)" }}
          src="/iPhAppStore.webp"
          alt="iPhone"
        />

        {/* Телефон */}

        {/* Белый градиент снизу */}
        <div
          className="absolute w-full h-[30%] bg-gradient-to-t from-white to-transparent pointer-events-none"
          style={{ bottom: 0 }}
        />

        {/* Кнопка App Store */}
        <a
          href="https://apps.apple.com/app/id6503243188"
          className="absolute w-[90%] sm:w-[70%] md:w-[50%] inline-flex gap-2 items-center justify-center bg-black text-white py-3 rounded-2xl shadow-lg transition hover:scale-105"
          style={{ bottom: "0", left: "50%", transform: "translateX(-50%)" }}
        >
          <svg
            fill="#ffffff"
            width="28"
            height="28"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M18.71 19.5C17.88 20.74 17 21.95 15.66 21.97C14.32 22 13.89 21.18 12.37 21.18C10.84 21.18 10.37 21.95 9.1 22C7.79 22.05 6.8 20.68 5.96 19.47C4.25 17 2.94 12.45 4.7 9.39C5.57 7.87 7.13 6.91 8.82 6.88C10.1 6.86 11.32 7.75 12.11 7.75C12.89 7.75 14.37 6.68 15.92 6.84C16.57 6.87 18.39 7.1 19.56 8.82C19.47 8.88 17.39 10.1 17.41 12.63C17.44 15.65 20.06 16.66 20.09 16.67C20.06 16.74 19.67 18.11 18.71 19.5ZM13 3.5C13.73 2.67 14.94 2.04 15.94 2C16.07 3.17 15.6 4.35 14.9 5.19C14.21 6.04 13.07 6.7 11.95 6.61C11.8 5.46 12.36 4.26 13 3.5Z"></path>
          </svg>
          <div className="flex flex-col">
            <p className="text-[10px] sm:text-xs leading-none">
              Download on the
            </p>
            <span className="text-sm sm:text-base font-medium">App Store</span>
          </div>
        </a>
      </div>
    </div>
  );
};

export default AppStore;
